module.exports = __webpack_public_path__ + "static/media/travvislogo.dc5f68bc.svg";